import { NotificationTypeEnum } from '../../types/notification';

export interface NotificationTypeMeta {
  /** Material Symbols icon name. */
  icon: string;
  color: string;
}

const META: Record<NotificationTypeEnum, NotificationTypeMeta> = {
  [NotificationTypeEnum.CHARGING_PREPARING]: { icon: 'power', color: '#f59e0b' },
  [NotificationTypeEnum.CHARGING_STARTED]: { icon: 'electric_bolt', color: '#10b981' },
  [NotificationTypeEnum.CHARGING_FINISHED]: { icon: 'check_circle', color: '#6366f1' },
  [NotificationTypeEnum.CHARGING_DOWNTIME]: { icon: 'hourglass_bottom', color: '#f97316' },
  [NotificationTypeEnum.STATION_DISCONNECTED]: { icon: 'power_off', color: '#ef4444' },
  [NotificationTypeEnum.SYSTEM_NEWS]: { icon: 'campaign', color: '#3b82f6' },
};

// The backend can ship types this build doesn't know yet — render a neutral
// bell instead of a blank circle.
const FALLBACK: NotificationTypeMeta = { icon: 'notifications', color: '#64748b' };

export function getNotificationTypeMeta(type: NotificationTypeEnum): NotificationTypeMeta {
  return META[type] ?? FALLBACK;
}
